// extracted by mini-css-extract-plugin
module.exports = {"switchContainer":"Switch_switchContainer__1jPWq","switchContainerActive":"Switch_switchContainerActive__1nv0z"};